/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentRecordFileInfoDto } from './incidentRecordFileInfoDto.schema';

export const IReadOnlyListOfIncidentRecordFileInfoDto = zod.array(zod.lazy(() => IncidentRecordFileInfoDto));

export type IReadOnlyListOfIncidentRecordFileInfoDto = zod.input<typeof IReadOnlyListOfIncidentRecordFileInfoDto>;
export type IReadOnlyListOfIncidentRecordFileInfoDtoOutput = zod.output<typeof IReadOnlyListOfIncidentRecordFileInfoDto>;
